module.exports = __webpack_public_path__ + "img/icon-pin.bc5ad1d9.svg";